import React, { useState } from "react";
import "../css/Afficher_Horaires.css";

const formatOpeningHours = (horaires) => {
  const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
  const formattedHours = days.map((day) => ({ day, slots: [] }));

  const horairesByDay = horaires.reduce((acc, { jour, ouverture, fermeture, rendez_vous }) => {
    const dayIndex = jour === 0 ? 6 : jour - 1;
    if (!acc[dayIndex]) acc[dayIndex] = [];
    acc[dayIndex].push({ ouverture, fermeture, rendez_vous });
    return acc;
  }, {});

  Object.entries(horairesByDay).forEach(([index, slots]) => {
    formattedHours[index].slots = slots;
  });

  return formattedHours;
};

const isCurrentlyOpen = (horaires) => {
  const now = new Date();
  const currentDay = now.getDay();
  const currentTime = now.getHours() * 100 + now.getMinutes();

  const todaySlots = horaires.filter(({ jour }) => jour === currentDay);
  for (const { ouverture, fermeture } of todaySlots) {
    const openingTime = parseInt(ouverture.slice(0, 2) + ouverture.slice(3, 5), 10);
    const closingTime = parseInt(fermeture.slice(0, 2) + fermeture.slice(3, 5), 10);

    if (currentTime >= openingTime && currentTime <= closingTime) {
      return true;
    }
  }
  return false;
};

export const PS_Horaires_Ouverture = ({ praticien, horaires, scrollDownDemanded, setScrollDownDemanded }) => {
  const [isOpen, setIsOpen] = useState(false);
  const formattedHours = formatOpeningHours(horaires);
  const isOpenNow = isCurrentlyOpen(horaires);
  const currentDayIndex = (new Date().getDay() + 6) % 7;

  

  return (
    <div className="opening-hours-container">
      <div className="opening-hours-header">
        <button onClick={() => setIsOpen(!isOpen)} className="opening-hours-button" style={{ display: 'flex', fontFamily: "Arial, sans-serif", fontWeight: 'bold', flexDirection: 'row' }}>
          <img src={isOpen ? "chevron-bas.png" : "chevron-droit.png"} className="chevron-icon" alt="Toggle" style={{ height: '15px', width: '15px', marginRight: '20%' }} />
          Horaires 
        </button>
        <div className="status-indicator">
          <span className="status-circle" style={{ backgroundColor: isOpenNow ? "green" : "red" }} />
          <span>{isOpenNow ? "Ouvert actuellement" : "Fermé actuellement"}</span>
        </div>
      </div>

      {isOpen && (
        <div className="opening-hours-list" style={{justifyContent: "space-around",margin: "0 0 0 0"}}>
          {formattedHours.map(({ day, slots }, index) => {
            const isToday = index === currentDayIndex;

            return (
              <div key={day} className="opening-hours-item" style={{ fontWeight: isToday ? "bold" : "normal" }}>
                
                <div className="day" style={{textAlign:'left'}}>{day}:</div>
                
                <div className="slots-list">
                  {slots.length > 0 ? (
                    <ul className="slots-list">
                      {slots.map(({ ouverture, fermeture }, idx) => (
                        <li key={idx} className="slot">
                          {ouverture.slice(0, 5)} - {fermeture.slice(0, 5)}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="closed">Fermé</span>
                  )}
                </div>

                <div className="rendez-vous-column">
                  {slots.length > 0 ? (
                    <ul className="rendez-vous-list">
                      {slots.map(({ rendez_vous }, idx) => (
                        <li key={idx} className="rendez-vous">
                          {rendez_vous === "avc_rdv" ? "sur rdv" : (rendez_vous === "ss_rdv" ? "sans rdv" : "")}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="closed"></span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
